import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UserProfileService } from 'src/app/core/api-services/user-profile/user-profile.service';
import { UserProfileLookups } from 'src/app/core/models/user-profile/user-profile.model';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import { InputPatterns } from 'src/app/shared/input-components/validators/InputPatterns';
import { ProfileMapper } from '../profile-mapper';

@Component({
  selector: 'app-profile-contact-info',
  templateUrl: 'profile-contact-info.html',
})
export class ProfileContactInfo extends BaseComponent implements OnInit {
  @Input() isPerson: boolean;
  @Input() lookups: UserProfileLookups;
  @Input() form: FormGroup;
  @Input() isRegistered: boolean = false;

 constructor(
     translateService: TranslateService,
     private _userProfileService: UserProfileService,
     private _mapper: ProfileMapper
   ) {
     super(translateService);
   }

  ngOnInit(): void {
    if (!this.isRegistered) {
      this.form.addControl('Email', new FormControl(null, Validators.required));
    }
    this.form.addControl(
      'Mobile',
      new FormControl(null, [
        Validators.required,
        Validators.minLength(10),
        Validators.maxLength(20),
      ])
    );
    this.form.addControl('City', new FormControl(null, Validators.required));
    this.form.addControl('PoBox', new FormControl(null, Validators.required));
    this.form.addControl(
      'PreferedLanguage',
      new FormControl(null, Validators.required)
    );
    this.form.addControl('Address', new FormControl(null, Validators.required));
    if (this.isPerson) {
      this.form.addControl(
        'Emirate',
        new FormControl(null, Validators.required)
      );
      //this.form.addControl("Address",new FormControl(null));
    }
    if (this.isRegistered) {
      this.form.addControl(
        'SecondaryMobile',
        new FormControl(null, [
          Validators.minLength(10),
          Validators.maxLength(20),
        ])
      );
      this.form.addControl('PhoneNumber', new FormControl());
      this.form.addControl('Fax', new FormControl());
      this.form.addControl(
        'ServiceCenter',
        new FormControl(null, Validators.required)
      );
      this.form.addControl('Area', new FormControl());
      this.form.addControl('Street', new FormControl());
      this.form.addControl(
        'NotificationTypes',
        new FormControl(null, Validators.required)
      );
    } else {
      this.form.addControl(
        'TermsAndConditions',
        new FormControl(null, Validators.required)
      );
    }
  }  
  

}
